// extracted by mini-css-extract-plugin
export default {"button":"DeleteButton_button__9N4lK","icon":"DeleteButton_icon__NS6qw"};